module.exports = __webpack_public_path__ + "static/media/cybercrime-large@3x.4ed23bc1.png";